import { render, staticRenderFns } from "./c-doses-grid.vue?vue&type=template&id=ef2a4c20&scoped=true&"
import script from "./c-doses-grid.vue?vue&type=script&lang=js&"
export * from "./c-doses-grid.vue?vue&type=script&lang=js&"
import style0 from "./c-doses-grid.vue?vue&type=style&index=0&id=ef2a4c20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2a4c20",
  null
  
)

export default component.exports